import { useState } from "react";
import styles from "./CreateMenuItemModal.module.css";
import Button from "../components/Button";
import { validateForm } from "../helpers/helperFunctions";
import { makeInvalid, flashAlert } from "../global_js";
import React from "react";
import { useEffect } from "react";
import AddSubmenuItemModal from "./AddSubmenuItemModal";

function CreateMenuItemModal({ menuCategories, location, getMenu, menuItems }) {
  const [isOpen, setIsOpen] = useState(false);
  //const navigate = useNavigate();
  const baseItem = {
    idBanquetMenu: 0,
    item: "",
    price: null,
    category: "",
    locationId: -1,
    hasSelections: false,
    selectionCount: 0,
    isPricePer: false,
    includeInMenu: false,
    active: true,
    selectedItems: [],
  };

  const [newItem, setNewItem] = useState(baseItem);
  const [isParent, setIsParent] = useState(false);

  const openModal = () => {
    setIsOpen((x) => !x);
  };
  const closeModal = () => {
    setIsOpen((x) => !x);
    setNewItem(baseItem);
  };

  const createMenuItem = async (e) => {
    e.preventDefault();
    let countInput = document.getElementById("selectionCountsInput");
    if (newItem.hasSelections) {
      countInput.setCustomValidity("");
      countInput.min = 1;
      countInput.removeAttribute("readOnly");
    }
    newItem.locationId = Number(location);
    if (validateForm(document.getElementById("createNewItemForm"))) {
      await fetch("/api/editmenu", {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(newItem),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.code) {
            flashAlert("The menu item did not save. Error: " + data.code, "error");
          } else {
            console.log(data);
            flashAlert("Menu Item Created", "success");
            getMenu();
            closeModal();
          }
        });
    }
  };

  useEffect(() => {
    if (newItem.category.endsWith("_ADD") || newItem.category.endsWith("_IT") || newItem.category == "SIDE" || newItem.category == "") {
      setIsParent(false);
    } else {
      setIsParent(true);
    }
  }, [newItem]);

  return (
    <>
      <Button type="tertiary" onClick={openModal}>
        Create new Menu Item
      </Button>
      {isOpen && (
        <div className={styles.modalBackdrop} id="createNewItemModal">
          <div className={`${styles.modalTop}`}>
            <h3 className={styles.modalHeader}>Create New Menu Item {location == 1 ? " - McMinnville" : " - Beaverton"}</h3>

            <div id="createNewItemForm" className={styles.otherMenuItemForm}>
              <h4>Enter Menu Item Details</h4>
              <div className={styles.menuFields}>
                <div className={styles.formSection}>
                  <label htmlFor="">Item Name</label>
                  <input
                    type="text"
                    className={styles.itemName}
                    name="description"
                    placeholder="Menu Item Name"
                    value={newItem.item}
                    onChange={(e) => setNewItem({ ...newItem, item: e.target.value })}
                    required
                    onInvalid={makeInvalid}
                    tabIndex={10}
                  />
                  <div className="invalid-feedback">Item name required</div>
                </div>
                <div className={styles.formSection}>
                  <label htmlFor="">Menu Category</label>
                  <select
                    name="category"
                    id=""
                    value={newItem.category}
                    onInvalid={makeInvalid}
                    onChange={(e) => setNewItem({ ...newItem, category: e.target.value })}
                    required
                    tabIndex={20}
                  >
                    <option selected="" value=""></option>
                    {menuCategories.map((menuCat) => {
                      return <option value={menuCat.id}>{menuCat.descriptions}</option>;
                    })}
                  </select>
                  <div className="invalid-feedback">Category is required</div>
                </div>
                <div className={styles.formSection}>
                  <label htmlFor="">Menu Price</label>
                  <input
                    type="number"
                    className={styles.otherPrice}
                    name="price"
                    step=".01"
                    value={newItem.price}
                    placeholder="Menu price"
                    onChange={(e) => setNewItem({ ...newItem, price: Number(e.target.value) })}
                    required
                    onInvalid={makeInvalid}
                    tabIndex={30}
                  />
                  <div className="invalid-feedback">Item price required</div>
                </div>
                <div className={styles.formSection}>
                  <label htmlFor="">Price per person?</label>
                  <select
                    name="isPricePer"
                    value={newItem.isPricePer}
                    onChange={(e) => setNewItem({ ...newItem, isPricePer: e.target.value === "true" ? true : false })}
                    tabIndex={40}
                  >
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </div>
                {isParent && (
                  <div className={styles.formSection}>
                    <label htmlFor="">Has Subitems</label>
                    <select
                      name="hasSelection"
                      value={newItem.hasSelections}
                      onChange={(e) => setNewItem({ ...newItem, hasSelections: e.target.value === "true" ? true : false })}
                      tabIndex={50}
                    >
                      <option value="true">Yes</option>
                      <option value="false">No</option>
                    </select>
                    {newItem.hasSelections && <AddSubmenuItemModal menuItems={menuItems} newItem={newItem} setNewItem={setNewItem} />}
                  </div>
                )}
                {newItem.hasSelections && (
                  <div className={styles.formSection}>
                    <label htmlFor="">Number of Subitems</label>
                    <input
                      type="number"
                      name="selectionCountsInput"
                      id="selectionCountsInput"
                      value={newItem.selectionCount}
                      onInvalid={makeInvalid}
                      tabIndex={60}
                    />
                    <div className="invalid-feedback">At least one selection required or select No subitems</div>
                  </div>
                )}
                <div className={styles.formSection}>
                  <label htmlFor="">Include in menu??</label>
                  <select
                    name="includeInMenu"
                    value={newItem.includeInMenu}
                    onChange={(e) => setNewItem({ ...newItem, includeInMenu: e.target.value === "true" ? true : false })}
                    tabIndex={70}
                  >
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </div>
                <div className={styles.formSection}>
                  <label htmlFor="">Active?</label>
                  <select
                    name="active"
                    value={newItem.active}
                    onChange={(e) => setNewItem({ ...newItem, active: e.target.value === "true" ? true : false })}
                    tabIndex={80}
                  >
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </div>
              </div>
              <div className={styles.formSelectButtons}>
                <Button type="secondary" onClick={createMenuItem} tabIndex={90}>
                  Create Menu Item
                </Button>
                <Button type="save" onClick={closeModal}>
                  Close
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default CreateMenuItemModal;
